<template>
  <div>
    <!-- Add an wrapper div here to avoid Vue throw error when isProductRestrictedInLocation is changed 
    The reason is that there is a v-show on router-view
  -->

    <div
      class="container page product"
      :class="{
        'product-ui-new-version': true,
        [productTypeClass]: productTypeClass,
        [productHandleClass]: productHandleClass,
      }"
    >
      <client-only>
        <TakeDownContent v-if="isProductRestrictedInLocation"></TakeDownContent>
      </client-only>
      <div v-show="!isProductRestrictedInLocation">
        <div class="product__breadcrumb">
          <sib-breadcrumb :items="breadcrumbItems"></sib-breadcrumb>
        </div>
        <div class="product-not-found" v-if="productStore.isProductNotFound">
          Product not found!
        </div>
        <section v-else class="product-page-container">
          <header class="product__header">
            <h1 class="product__title">
              <template v-if="!product">
                <sib-skeleton-loading round="sm"></sib-skeleton-loading>
                <sib-skeleton-loading
                  round="sm"
                  width="75%"
                ></sib-skeleton-loading>
              </template>
              <template v-else>
                {{ product.title }}
              </template>
            </h1>

            <h2 class="product__price" style="display: block">
              <span class="product__price-final" v-if="finalDisCountApplied">
                {{ formatPrice(finalDisCountApplied?.price) }}
              </span>
              <sib-skeleton-loading class="mb-sm" v-else round="sm" width="6em">
              </sib-skeleton-loading>
              <span
                class="product__price-currency"
                style="margin-left: 6px; font-size: large; color: #666"
                >USD</span
              >
              <span
                class="product__price-compare"
                style="font-size: large"
                v-if="finalDisCountApplied?.compareAtPrice"
              >
                {{ formatPrice(finalDisCountApplied?.compareAtPrice) }} USD
              </span>
            </h2>
            <client-only>
              <div
                class="product__google-discount-messages"
                v-if="googleDiscountCode && !isCampaignDiscount"
              >
                <p>
                  {{ googleDiscountMessage }}

                  <span
                    v-if="!googleDiscountApplied"
                    class="product__google-discount-action"
                    @click="applyGoogleDiscount"
                  >
                    CLAIM NOW</span
                  >
                </p>
              </div>
              <div
                class="product__discount-messages mt-xs"
                v-if="
                  ((finalDisCountApplied as any)?.messages?.length ||
                    packDiscountApplied?.messages?.length) &&
                  !priceDonated &&
                  !googleDiscountCode
                "
              >
                <span
                  class="product__discount-message"
                  v-for="(message, index) of packDiscountApplied?.messages ||
                  (finalDisCountApplied as any)?.messages"
                  :key="index"
                >
                  {{ message }}
                </span>
              </div>

              <div
                class="product__discount-messages mt-xs"
                v-if="
                  descriptionDonation && priceDonated && !googleDiscountCode
                "
                v-html="
                  descriptionDonation.replaceAll(
                    `{price}`,
                    formatPrice(priceDonated)
                  )
                "
              ></div>

              <!-- Displays the discount percentage for products configured to compare price in the store -->
              <div
                class="product__discount-messages mt-xs"
                v-if="
                  !(finalDisCountApplied as any)?.messages?.length &&
                  !packDiscountApplied?.messages?.length &&
                  !isCampaignDiscount &&
                  !discountStore.discountCode &&
                  !priceDonated &&
                  !googleDiscountCode &&
                  percentDiscountDefault
                "
              >
                <span
                  class="product__discount-message product__discount-message-secondary"
                >
                  {{ percentDiscountDefault }}% off
                </span>
              </div>

              <!-- PayPal Pay Later Messaging -->
              <PaypalPayLaterMessage
                v-if="finalDisCountApplied"
                :amount="finalDisCountApplied.price"
                placement="product"
                style="margin-top: 8px"
              />

              <div
                class="product__sumary-review"
                :class="{
                  'product__sumary-review--treatment': false,
                  'mt-sm': hasReviews,
                }"
              >
                <sib-tooltip text="Click to see all reviews" :disabled="!false">
                  <div v-show="jdgmPreviewBadgeLoading">
                    <div
                      v-if="productStore.product?.id"
                      :key="productStore.product?.id"
                      class="jdgm-widget jdgm-preview-badge"
                      :data-id="productRawId"
                      @click="handleRatingClick"
                    ></div>
                  </div>
                  <div v-show="!jdgmPreviewBadgeLoading">
                    <sib-skeleton-loading round="sm" width="8em" height="19px">
                    </sib-skeleton-loading>
                    <sib-skeleton-loading
                      class="ml-xs"
                      round="sm"
                      width="7em"
                      height="19px"
                    >
                    </sib-skeleton-loading>
                  </div>
                </sib-tooltip>
              </div>
            </client-only>
          </header>
          <ProductImages />
          <div class="product__info">
            <template v-if="isQrGreetingCardProductType">
              <h4 class="mt-md mb-sm">
                Video Demo of QR Greeting Card with Digital Content
              </h4>
              <sib-video
                :style="'width:100%'"
                src="https://cdn.shopify.com/videos/c/o/v/aebb1d1b559141738fa836ee372c0cf6.mp4"
                autoplay
              ></sib-video>
            </template>

            <template v-if="!isDigitalProductProductType">
              <ProductForm :loading="isProductPageLoading" />
              <client-only>
                <ProductNote />
                <ProductDiscountIncentive v-if="isDiscountIncentiveCampaign" />
              </client-only>
            </template>
            <client-only>
              <template v-if="isDigitalProductProductType">
                <sib-button
                  role="primary"
                  @click="downloadArtwork()"
                  :loading="loading"
                >
                  DOWNLOAD ARTWORK
                </sib-button>
                <p class="error-message" v-show="isError">
                  {{ errorMessage }}
                </p>
              </template>
            </client-only>
            <!-- Using client only for under the fold components to reduce the number of DOM that server needs to render
          Thought, increasing the server response time and reducing the page size
          -->
            <client-only
              :is-show="componentStore.productPage.isShowPeopleViewing"
            >
              <template #placeholder>
                <div
                  ref="peopleViewingPlaceholder"
                  :data-key="PEOPLE_VIEWING_COMPONENT_KEY"
                ></div>
                <sib-skeleton-loading
                  height="2em"
                  class="mt-sm"
                ></sib-skeleton-loading>
              </template>
              <PeoplesViewing v-if="product" />
            </client-only>

            <client-only
              :is-show="componentStore.productPage.isShowProductDescription"
            >
              <template #placeholder>
                <div
                  :data-key="PRODUCT_DESCRIPTION_COMPONENT_KEY"
                  ref="productDescriptionPlaceholder"
                ></div>
                <sib-skeleton-loading
                  height="5em"
                  class="mt-sm"
                ></sib-skeleton-loading>
              </template>
              <ProductDescription />
            </client-only>

            <client-only
              :is-show="componentStore.productPage.isShowProductShipping"
            >
              <template #placeholder>
                <div
                  :data-key="SHIPPING_COMPONENT_KEY"
                  ref="shippingPlaceholder"
                ></div>
                <sib-skeleton-loading
                  height="5em"
                  class="mt-sm"
                ></sib-skeleton-loading>
              </template>
              <ProductShipping v-if="!isDigitalContentProductType" />
            </client-only>
          </div>
        </section>

        <client-only>
          <template
            v-for="(section, index) in productUINewVersionLayoutComponentData"
            :key="index"
          >
            <client-only
              :is-show="shouldShowUINewVersionComponents[section._key] || false"
            >
              <template #placeholder>
                <div
                  ref="uiNewVersionplaceholders"
                  :data-key="section._key"
                ></div>
                <sib-skeleton-loading
                  height="10rem"
                  class="mb-sm"
                ></sib-skeleton-loading>
              </template>
              <component
                :is="productComponents[section._type]"
                :section="section"
                :productSeeMoreCollections="productSeeMoreCollections"
                :discountAppliedFirstProductVariant="
                  discountAppliedFirstProductVariant
                "
              />
            </client-only>
          </template>
        </client-only>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PaypalPayLaterMessage from '@/components/PaypalPayLaterMessage.vue'
import ProductDiscountIncentive from '@/components/product/ProductDiscountIncentive.vue'
import ProductImages from './ProductImages.vue'
import ProductForm from './ProductForm.vue'
import ProductNote from './ProductNote.vue'
import {
  buildCollectionUrl,
  formatPrice,
  getRawIdFromShopifyId,
  isProductHasTags,
  isProductHasType,
  isProductHasTypeStartWith,
  extractProductCodeAndNicheCodeFromHandle,
} from '@/utils/product'
import { useProduct } from './composables/Product'
import {
  onMounted,
  watch,
  nextTick,
  ref,
  defineAsyncComponent,
  Ref,
  WatchStopHandle,
  onUnmounted,
  reactive,
} from 'vue'
import { useProductRecentlyViewedItems } from './composables/ProductRecentlyViewed'
import { useApplyFakePriceDiscountBF9 } from './composables/ProductFakePrice'
import { computed } from '@vue/reactivity'
import { useRoute } from 'vue-router'
import useComponentStore from '@/store/component'
import {
  EVENT_SCROLL_TO_REVIEW_SECTION,
  PRODUCT_AVERAGE_REVIEW_META_FIELD_KEY,
  PRODUCT_REVIEW_META_FIELD_NAMESPACE,
  HEADER_HEIGHT,
  PRODUCT_TYPE_GREETING_CARD,
  PACK_OPTIONS,
  CAMPAIGN_DISCOUNT_BLACKFRIDAY9,
  PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE,
  PRODUCT_TYPE_DIGITAL_PRODUCT,
  EVENT_OPEN_POPUP_SIGN_IN,
  PRODUCT_TYPE_QR_GREETING_CARD,
  PRODUCT_TAG_PROMOTION_NO,
  SEVEN_DAYS_IN_MILLISECONDS,
  CACHE_KEY_DISCOUNT_CODE,
  PROMOTION_GOOGLE_DISCOUNT_MESSAGE,
  PROMOTION_GOOGLE_DISCOUNT_MESSAGE_APPLIED,
  AB_TEST_VARIANT_DISABLE,
  PRODUCT_TAG_IGN_PACK_DISCOUNT,
  PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
  AB_TEST_PRODUCT_COMBO,
  PRODUCT_TAG_APPLY_FAKE_PRICE_BF9_BUT_NO_DISCOUNT,
  CAMPAIGN_FAKE_PRICE_BF9_BUT_NO_DISCOUNT,
  EVENT_SHOW_AVERAGE_START_PRE_BAGDE,
  PROMOTION_BAR_TYPE_DISCOUNT,
  PROMOTION_BAR_PRIORITY_MEDIUM,
} from '@/utils'
import EventBus from '@/services/eventbus'
import useSettingStore from '@/store/setting'
import useProductStore from '@/store/product'
import Logger from '@/services/log'
import Analytics from '@/services/analytics'
import useDiscountStore from '@/store/discount'
import useCartStore from '@/store/cart'
import useMediaCampaignStore from '@/store/media'
import useCustomerStore from '@/store/customer'
import Provider from '@/provider'
import CacheService from '@/services/cache'
import useDiscount from '@/composables/applyDiscount'
import { buildGoogleDiscountMessage } from '@/utils/discount'
import { useABTest } from '@/composables/useABTest'
import { useProductCombo } from './composables/useProductCombo'
import useABTestStoreV2 from '@/composables/abtest/store'
import { PDP_DISCOUNT_INCENTIVE_CAMPAIGN } from '@/composables/abtest/contexts/abtestContextPdpDiscountIncentive'

const { applyDiscount, getValueFromDiscountCode } = useDiscount()
const customerStore = useCustomerStore()
const { getABTestActivedVariantByCode } = useABTest()
const { getComboCartLineItemNotCompleted } = useProductCombo()
const { applyFakePriceDiscountBF9 } = useApplyFakePriceDiscountBF9()

const abtestStore = useABTestStoreV2()
const isMounted = ref(false)

const isDiscountIncentiveCampaign = computed(() => {
  return (
    shouldShowBuyMoreSaveMore.value &&
    isProductUINewVersion.value &&
    abtestStore.isReady &&
    abtestStore.code === PDP_DISCOUNT_INCENTIVE_CAMPAIGN.code &&
    abtestStore.output?.inTest !== false
  )
})

const comboCartLineItemNotCompleted = ref(null)

const customer = computed(() => customerStore.customer)

const TakeDownContent = defineAsyncComponent(
  () => import('@/components/TakeDownContent.vue')
)
const ProductDescription = defineAsyncComponent(
  () => import('./ProductDescription.vue')
)
const ProductShipping = defineAsyncComponent(
  () => import('./ProductShipping.vue')
)
const PeoplesViewing = defineAsyncComponent(
  () => import('./PeoplesViewing.vue')
)
const productComponents: { [key: string]: any } = {
  baseSection: defineAsyncComponent(
    () => import('@/components/product/ProductBaseSection.vue')
  ),
  customHtml: defineAsyncComponent(
    () => import('@/components/product/ProductCustomHtml.vue')
  ),
  videoReviews: defineAsyncComponent(
    () => import('@/components/product/ProductVideoReviews.vue')
  ),
  imageReviews: defineAsyncComponent(
    () => import('@/components/product/ProductImageReviews.vue')
  ),
  shopNowButton: defineAsyncComponent(
    () => import('@/components/product/ShopNowButton.vue')
  ),
  metaFieldProduct: defineAsyncComponent(
    () => import('@/components/product/ProductMetaField.vue')
  ),
  judgemeReviews: defineAsyncComponent(
    () => import('./ProductReviewJudgeme.vue')
  ),
  recommendation: defineAsyncComponent(
    () => import('./ProductRecommendation.vue')
  ),
  recommendMoreItems: defineAsyncComponent(
    () => import('@/components/product/ProductRecommendMoreItems.vue')
  ),
  recommendNonNicheItems: defineAsyncComponent(
    () => import('@/components/product/ProductRecommendNonNicheItems.vue')
  ),
  recommendSimilarItems: defineAsyncComponent(
    () => import('@/components/product/ProductRecommendSimilarItems.vue')
  ),
  blogs: defineAsyncComponent(
    () => import('@/components/product/ProductBlogs.vue')
  ),
  comparePriceOtherSite: defineAsyncComponent(
    () => import('@/components/product/ProductComparePriceOtherSite.vue')
  ),
}

const shouldShowUINewVersionComponents = reactive<{ [key: string]: boolean }>(
  {}
)
const uiNewVersionplaceholders = ref([])

const PEOPLE_VIEWING_COMPONENT_KEY = 'people-viewing'
const PRODUCT_DESCRIPTION_COMPONENT_KEY = 'product-description'
const SHIPPING_COMPONENT_KEY = 'shipping'
const peopleViewingPlaceholder = ref<HTMLDivElement | null>(null)
const productDescriptionPlaceholder = ref<HTMLDivElement | null>(null)
const shippingPlaceholder = ref<HTMLDivElement | null>(null)
const productReviewPlaceholder = ref<HTMLDivElement | null>(null)
let observer: IntersectionObserver | null = null
let sectionObserver: IntersectionObserver | null = null

const placeHolderAndHandlerMap: {
  [key: string]: {
    placeholder: Ref<HTMLDivElement | null>
    handler: () => void
  }
} = {
  [PEOPLE_VIEWING_COMPONENT_KEY]: {
    placeholder: peopleViewingPlaceholder,
    handler() {
      componentStore.productPage.isShowPeopleViewing = true
      Logger.log('showing people viewing component', 3)
    },
  },
  [PRODUCT_DESCRIPTION_COMPONENT_KEY]: {
    placeholder: productDescriptionPlaceholder,
    handler() {
      componentStore.productPage.isShowProductDescription = true
      Logger.log('showing product description component', 3)
    },
  },
  [SHIPPING_COMPONENT_KEY]: {
    placeholder: shippingPlaceholder,
    handler() {
      componentStore.productPage.isShowProductShipping = true
      Logger.log('showing product shipping component', 3)
    },
  },
}

const mediaCampaignStore = useMediaCampaignStore()
const cartStore = useCartStore()
const discountStore = useDiscountStore()
const componentStore = useComponentStore()
const settingStore = useSettingStore()
const productStore = useProductStore()
const route = useRoute()
const {
  product,
  discountApplied,
  discountAppliedFirstProductVariant,
  isProductRestrictedInLocation,
  productSeeMoreCollections,
  trackRecentlyViewedTraits,
  loading: isProductPageLoading,
} = useProduct()
const { saveProductToCache } = useProductRecentlyViewedItems()
const productAverageReview = ref<HTMLDivElement | null>(null)
const productAverageReviewHtml = computed(() => {
  return (
    product.value?.metafields?.find((elm) => {
      if (!elm) return false
      return (
        elm?.key == PRODUCT_AVERAGE_REVIEW_META_FIELD_KEY &&
        elm?.namespace == PRODUCT_REVIEW_META_FIELD_NAMESPACE
      )
    })?.value || ''
  )
})

const loading = ref(false)
const jdgmPreviewBadgeLoading = ref(false)
const hasReviews = ref(true)
const isError = ref(false)
let errorMessage = ref('Something went wrong. Please try again later.')

const productUINewVersionLayoutData = computed(() => {
  if (!product.value) return
  const productLayoutComponentBaseOnHandle =
    settingStore.productLandingPage?.productPageComponentsNewVersion?.find(
      (item: any) => item.handle == product.value?.handle
    )
  if (productLayoutComponentBaseOnHandle) {
    return productLayoutComponentBaseOnHandle
  }
  const productCodeAndNicheCodeFromHandle =
    extractProductCodeAndNicheCodeFromHandle(product.value.handle)

  const productLayoutComponentBaseOnProductTypeAndNiche =
    settingStore.productLandingPage?.productPageComponentsNewVersion?.find(
      (item: any) =>
        item.nicheCode &&
        item.productTypeCode &&
        productCodeAndNicheCodeFromHandle.includes(item.nicheCode) &&
        productCodeAndNicheCodeFromHandle.includes(item.productTypeCode)
    )

  if (productLayoutComponentBaseOnProductTypeAndNiche) {
    return productLayoutComponentBaseOnProductTypeAndNiche
  }

  const productLayoutComponentBaseOnNiche =
    settingStore.productLandingPage?.productPageComponentsNewVersion?.find(
      (item: any) =>
        item.nicheCode &&
        !item.productTypeCode &&
        productCodeAndNicheCodeFromHandle.includes(item.nicheCode)
    )

  if (productLayoutComponentBaseOnNiche) {
    return productLayoutComponentBaseOnNiche
  }

  const productLayoutComponentBaseOnProductType =
    settingStore.productLandingPage?.productPageComponentsNewVersion?.find(
      (item: any) =>
        item.productTypeCode &&
        !item.nicheCode &&
        productCodeAndNicheCodeFromHandle.includes(item.productTypeCode)
    )
  if (productLayoutComponentBaseOnProductType) {
    return productLayoutComponentBaseOnProductType
  }
  if (
    settingStore.productLandingPage?.newUIProductPageComponentsDefault
      ?.components?.length
  ) {
    return settingStore.productLandingPage?.newUIProductPageComponentsDefault
  }
  return
})

const productUINewVersionLayoutComponentData = computed(() => {
  if (productUINewVersionLayoutData.value?.components?.length)
    return productUINewVersionLayoutData.value?.components
  return []
})

const isProductUINewVersion = computed(() => {
  productStore.isProductUINewVersion = true
  return true
})

const productRawId = computed(() =>
  getRawIdFromShopifyId(productStore.product?.id)
)

const isProductPackOption = computed(() => {
  if (!product.value) return []
  const index = product.value.options?.findIndex((item) =>
    item.name?.includes(PACK_OPTIONS)
  )
  return index > -1
})
const isDigitalProductProductType = computed(() => {
  return isProductHasType(productStore?.product, [PRODUCT_TYPE_DIGITAL_PRODUCT])
})
const isQrGreetingCardProductType = computed(() => {
  return isProductHasType(productStore?.product, [
    PRODUCT_TYPE_QR_GREETING_CARD,
  ])
})

const googleDiscountCode = computed(
  () => discountStore.googleDiscountCode || ''
)

const googleDiscountApplied = computed(
  () => discountStore.googleDiscountApplied
)

const googleDiscountMessage = computed(() => {
  if (!googleDiscountCode) return ''
  const price = product.value?.price || 0
  const percentageGoogleDiscount = getValueFromDiscountCode(
    googleDiscountCode.value
  )
  const discountAmount =
    +((price * percentageGoogleDiscount) / 100).toFixed(2) || 0
  const priceDiscount = +(price - discountAmount).toFixed(2) || 0

  if (googleDiscountApplied.value) {
    return buildGoogleDiscountMessage(
      googleDiscountCode.value,
      discountAmount,
      PROMOTION_GOOGLE_DISCOUNT_MESSAGE_APPLIED
    )
  } else {
    return buildGoogleDiscountMessage(
      googleDiscountCode.value,
      priceDiscount,
      PROMOTION_GOOGLE_DISCOUNT_MESSAGE
    )
  }
})

const isCampaignDiscountBlackfriday9 = computed(
  () =>
    discountStore.campaignDiscountCode?.toLowerCase() ==
    CAMPAIGN_DISCOUNT_BLACKFRIDAY9
)
const isCampaignDiscount = computed(() =>
  discountStore.campaignDiscountCode?.toLowerCase()
)

const packDiscountApplied = computed(() => {
  if (
    isProductPackOption.value &&
    isCampaignDiscountBlackfriday9.value &&
    !isProductHasTags(productStore.product, [
      PRODUCT_TAG_IGN_PACK_DISCOUNT,
      PRODUCT_TAG_COMBO_PACK_MULTI_PERSONALIZE,
    ])
  ) {
    const price = productStore.selectedVariant?.price || 0
    return {
      amount: PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE,
      amountFormated: PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE,
      compareAtPrice: price,
      price:
        price *
        ((100 - PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE) / 100),
      messages: [`${PERCENTAGE_DISCOUNT_BF9_FOR_PACK_OPTION_PERCENTAGE}% off`],
    }
  }
  return
})

const isGreetingCardFlow = computed(() => mediaCampaignStore.greetingCardFlow)
const greetingCardDiscountApplied = computed(() => {
  const isProductGreetingCard = isProductHasType(product.value, [
    PRODUCT_TYPE_GREETING_CARD,
  ])
  const isProductTypeGreetingCardInLineItems =
    cartStore.localCartLineItems.find((lineItem) =>
      isProductHasType(lineItem?.merchandise?.product, [
        PRODUCT_TYPE_GREETING_CARD,
      ])
    )
  if (
    isGreetingCardFlow.value &&
    isProductGreetingCard &&
    cartStore.localCartLineItems.length &&
    !isProductTypeGreetingCardInLineItems
  ) {
    return {
      amount: 100,
      amountFormated: 100,
      compareAtPrice: product.value?.compareAtPrice || product.value?.price,
      price: 0,
    }
  }
  return
})

const donationDiscountApplied = computed(() => {
  if (priceDonated.value) {
    return {
      amount: 0,
      amountFormated: 0,
      compareAtPrice: product.value?.compareAtPrice || 0,
      price: product.value?.price || 0,
    }
  }
  return
})

const descriptionDonation = computed(() => {
  return mediaCampaignStore.kolCampaign?.description
})

const priceDonated = computed(() => {
  if (
    !mediaCampaignStore.donationCode ||
    !mediaCampaignStore.kolCampaign ||
    mediaCampaignStore.kolCampaign.donateConfiguration.length != 1
  )
    return ''
  const price =
    ((product.value?.price || 0) *
      mediaCampaignStore.kolCampaign.totalAmountPercentage) /
    100

  return price
})

const comboDiscountApplied = computed(() => {
  const abtestVariant = getABTestActivedVariantByCode(AB_TEST_PRODUCT_COMBO)
  if (
    !productStore.productComboSelected ||
    !comboCartLineItemNotCompleted.value ||
    abtestVariant == AB_TEST_VARIANT_DISABLE
  )
    return ''
  const price = product.value?.price || 0
  return {
    amount: productStore.productComboSelected.discountValue,
    compareAtPrice: price,
    price:
      price -
      (productStore.productComboSelected.discountType == 'amount'
        ? productStore.productComboSelected.discountValue
        : Math.ceil(
            price * (productStore.productComboSelected.discountValue / 100)
          )),
    messages: [
      `${
        productStore.productComboSelected.discountType == 'amount'
          ? '$' + productStore.productComboSelected.discountValue
          : productStore.productComboSelected.discountValue + '%'
      } off`,
    ],
  }
})

const hasFakePriceBF9ButNoDiscountProductTag = computed(() =>
  isProductHasTags(product.value, [
    PRODUCT_TAG_APPLY_FAKE_PRICE_BF9_BUT_NO_DISCOUNT,
  ])
)

const fakePriceBF9Applied = computed(() => {
  const campaignFakePriceBF9ButNoDiscount =
    discountStore.campaignDiscountCode ==
    CAMPAIGN_FAKE_PRICE_BF9_BUT_NO_DISCOUNT

  if (
    (!hasFakePriceBF9ButNoDiscountProductTag.value &&
      !campaignFakePriceBF9ButNoDiscount) ||
    !product.value
  ) {
    return
  }

  const selectedVariant = productStore.selectedVariant
  return applyFakePriceDiscountBF9(
    product.value,
    selectedVariant?.priceV2?.amount || 0,
    selectedVariant?.compareAtPriceV2?.amount || 0,
    selectedVariant?.sku
  )
})

const finalDisCountApplied = computed(() => {
  if (comboDiscountApplied.value) {
    return comboDiscountApplied.value
  } else if (donationDiscountApplied.value) {
    return donationDiscountApplied.value
  } else if (greetingCardDiscountApplied.value) {
    return greetingCardDiscountApplied.value
  } else if (packDiscountApplied.value) {
    return packDiscountApplied.value
  } else if (fakePriceBF9Applied.value) {
    return fakePriceBF9Applied.value
  }
  return discountApplied.value
})

const percentDiscountDefault = computed(() => {
  const selectedVariant = productStore.selectedVariant
  if (
    !selectedVariant ||
    !selectedVariant?.compareAtPrice ||
    !selectedVariant?.price
  ) {
    return
  }

  return Math.round(
    ((selectedVariant.compareAtPrice - selectedVariant.price) /
      selectedVariant.compareAtPrice) *
      100
  )
})

const shouldShowBuyMoreSaveMore = computed(() => {
  if (!product.value) return true

  const isHasProductTagPromotionNo = isProductHasTags(product.value, [
    PRODUCT_TAG_PROMOTION_NO,
  ])

  if (isHasProductTagPromotionNo) return false

  if (discountStore.campaignDiscountCode) {
    return !settingStore.shop?.campaignDiscountCodesThatIgnoreVolumnDiscount?.some(
      (campaignDiscountCode) =>
        discountStore.campaignDiscountCode?.toLowerCase() ===
        campaignDiscountCode.toLowerCase()
    )
  }

  return (
    !isProductHasType(
      product.value,
      settingStore.shop?.productTypesThatIgnoreVolumnDiscount || []
    ) && !isProductPackOption.value
  )
})

const isDigitalContentProductType = computed(() => {
  return isProductHasTypeStartWith(productStore?.product, 'digital')
})

let unwatchCombo: WatchStopHandle | null = null

onMounted(() => {
  isMounted.value = true

  unwatchCombo = watch(
    [() => productStore.productComboSelected, () => cartStore.cart?.id],
    () => {
      comboCartLineItemNotCompleted.value = getComboCartLineItemNotCompleted()
    },
    { immediate: true }
  )

  async function addProductAverageReviews() {
    // add product average reviews
    if (product.value) {
      await nextTick()
      if (!productAverageReview.value) return
      productAverageReview.value.innerHTML = productAverageReviewHtml.value
      await nextTick()
      const averageReviewElement = document.querySelector('.jdgm-widget')
      if (!averageReviewElement) return
      averageReviewElement.addEventListener('click', () => {
        // scroll to review placeholder if it exists
        if (productReviewPlaceholder.value) {
          const currentTop =
            productReviewPlaceholder.value.getBoundingClientRect().top
          window.scrollTo({
            top: window.scrollY + currentTop - HEADER_HEIGHT,
            behavior: 'smooth',
          })
        } else {
          // other wise scroll to real review section
          EventBus.trigger(EVENT_SCROLL_TO_REVIEW_SECTION)
        }
      })
    }
  }

  async function updateRecentlyViewedProducts() {
    if (product.value) {
      await saveProductToCache(product.value)
      Analytics.excuteOnReady(trackRecentlyViewedTraits)
    }
  }

  watch(
    product,
    async () => {
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(() => updateRecentlyViewedProducts())
      } else {
        setTimeout(() => updateRecentlyViewedProducts(), 200)
      }
      addProductAverageReviews()

      if (product.value && hasFakePriceBF9ButNoDiscountProductTag.value) {
        const campaignBF9 = settingStore.campaigns?.find(
          (item: any) =>
            item?.code?.toLowerCase() == CAMPAIGN_DISCOUNT_BLACKFRIDAY9
        )
        componentStore.addPromotionBarContent({
          type: PROMOTION_BAR_TYPE_DISCOUNT,
          priority: PROMOTION_BAR_PRIORITY_MEDIUM,
          value: campaignBF9?.promotionMessage || 'Sale up to 70% off!',
        })
      }

      if (observer) {
        observer.disconnect()
      }

      const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 800
      const options = {
        root: null,
        rootMargin: `-${viewportHeight / 2}px 0px 0px 0px`,
        threshold: 1,
      }

      const intersectPlaceholderCallback = (
        entries: IntersectionObserverEntry[]
      ) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const componentKey = (entry.target as HTMLElement).dataset.key
            const placeholderAndHandler =
              placeHolderAndHandlerMap[componentKey || '']
            if (placeholderAndHandler) {
              placeholderAndHandler.handler()
              if (placeholderAndHandler.placeholder.value && observer) {
                observer.unobserve(placeholderAndHandler.placeholder.value)
              }
            }
          }
        })
      }
      
      await nextTick()

      observer = new IntersectionObserver(intersectPlaceholderCallback, options)
      for (const key in placeHolderAndHandlerMap) {
        if (
          Object.prototype.hasOwnProperty.call(placeHolderAndHandlerMap, key)
        ) {
          const placeHolderAndHandler = placeHolderAndHandlerMap[key]
          if (
            placeHolderAndHandler.placeholder &&
            placeHolderAndHandler.placeholder.value
          ) {
            observer.observe(placeHolderAndHandler.placeholder.value)
          }
        }
      }

      if (productUINewVersionLayoutComponentData.value?.length) {
        productUINewVersionLayoutComponentData.value.forEach((section: any) => {
          if (section._type == 'videoReviews') {
            shouldShowUINewVersionComponents[section._key] = false
          } else {
            shouldShowUINewVersionComponents[section._key] = true
          }
        })
        const intersectSectionCallback = function (
          entries: IntersectionObserverEntry[]
        ) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const componentKey = (entry.target as HTMLElement).dataset.key
              if (componentKey) {
                shouldShowUINewVersionComponents[componentKey] = true
              }
              const placeholder = uiNewVersionplaceholders.value.find(
                (placeholder: any) => placeholder.dataset.key === componentKey
              )
              if (placeholder && sectionObserver) {
                sectionObserver.unobserve(placeholder)
              }
            }
          })
        }
        const sectionOptions = {
          rootMargin: `${viewportHeight / 3}px`,
        }
        if (sectionObserver) {
          sectionObserver.disconnect()
        }
        sectionObserver = new IntersectionObserver(
          intersectSectionCallback,
          sectionOptions
        )
        setTimeout(() => {
          uiNewVersionplaceholders.value.forEach((placeholder) => {
            sectionObserver?.observe(placeholder)
          })
        })
      }
    },
    { immediate: true }
  )
  EventBus.on(EVENT_SHOW_AVERAGE_START_PRE_BAGDE, (numberOfReviews) => {
    jdgmPreviewBadgeLoading.value = true
    if (numberOfReviews === 0 || numberOfReviews === '0') {
      hasReviews.value = false
    }
  })
})

const productHandleClass = computed(() =>
  product.value?.handle ? `product-handle__${product.value?.handle}` : ''
)

const productTypeClass = computed(() =>
  product.value?.handle
    ? `product-type__${product.value?.productType?.replace(/\s+/g, '')}`
    : ''
)

function handleRatingClick() {
  Analytics.track('rating_click', {
    product_id: product.value?.id,
  })
}

async function applyGoogleDiscount() {
  try {
    await CacheService.instance?.set(
      CACHE_KEY_DISCOUNT_CODE,
      googleDiscountCode.value,
      SEVEN_DAYS_IN_MILLISECONDS
    )
    await applyDiscount()

    // apply discount code for cart
    if (
      discountStore.discountCode &&
      !cartStore.discountCodeCurrentApply &&
      cartStore.cart?.lines?.length
    ) {
      await cartStore.cartDiscountCodeApply(discountStore.discountCode)
    }
  } catch (error) {
    // do nothing
  }
}

async function downloadArtwork() {
  if (!customer.value || !customerStore.accessToken) {
    EventBus.trigger(EVENT_OPEN_POPUP_SIGN_IN)
    return
  }

  loading.value = true

  const provider = await Provider.getInstance()
  const response = await provider.dowloadArtwork(
    productStore.product?.id,
    customerStore.accessToken
  ) as any
  if (response?.success) {
    let a = document.createElement('a')
    a.href = response?.data?.image
    a.download = 'output.png'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  } else {
    isError.value = true
    errorMessage.value = response?.message
  }

  loading.value = false
}

onUnmounted(() => {
  if (unwatchCombo) {
    unwatchCombo()
    unwatchCombo = null
  }
  if (observer) {
    observer.disconnect()
    observer = null
  }
  if (sectionObserver) {
    sectionObserver.disconnect()
    sectionObserver = null
  }

  if (hasFakePriceBF9ButNoDiscountProductTag.value) {
    componentStore.removePromotionBarContent(PROMOTION_BAR_TYPE_DISCOUNT)
  }
})

const breadcrumbItems = computed(() => {
  if (!product.value) return []
  const collectionHandle = route.params.collectionHandle
  const collections = product.value.collections
  let collection
  if (collectionHandle) {
    collection = collections.find((c) => c.handle === collectionHandle)
  }
  if (!collection && productSeeMoreCollections.value) {
    collection =
      productSeeMoreCollections.value.nicheCollection ||
      productSeeMoreCollections.value.typeCollection
  }

  if (!collection) {
    collection = collections[0]
  }
  if (!collection) return []
  return [
    {
      url: buildCollectionUrl(collection.handle),
      name: collection.title,
    },
    {
      url: `/products/${product.value.handle}`,
      name: product.value.title,
    },
  ]
})
</script>

<style lang="scss">
.product-page-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'b'
    'a'
    'c';

  @include media-md-up {
    grid-template-columns: 50% 1fr;
    grid-template-areas:
      'a b'
      'a c';
    column-gap: 2em;
    align-items: start;
  }
}

.product-ui-landing .product-page-container,
.product-ui-new-version .product-page-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'a'
    'b'
    'c';
  @include media-md-up {
    grid-template-columns: 50% 1fr;
    grid-template-areas:
      'a b'
      'a c';
    column-gap: 2em;
    align-items: start;
  }
  .product {
    &__header {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-areas:
        'f'
        'd'
        'e';
      @include media-md-up {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-areas:
          'd'
          'e'
          'f';
      }
    }

    @include media-md-down {
      &__images {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .carousel__button {
          background: none;
          bottom: calc(-50px - 1rem);
          top: unset;
          transform: unset;
          color: var(--text-color-secondary);
        }
        .carousel {
          margin-bottom: 0;
          &__item img {
            border-radius: 2rem;
          }
          &__dots {
            display: none;
          }
        }
      }
      &__thumbnail-slider {
        width: 80%;
        position: unset;
        display: flex;
        flex-direction: row;
        margin: auto;
      }
      &__thumbnail {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 1rem;
        min-width: calc(20% + 0.6rem);
        width: auto;
        aspect-ratio: 1;
        min-height: unset;
        border: solid 2px #ffffff;
        &::before {
          background: unset;
        }
        &--active {
          border: solid 2px var(--color-primary);
        }
        &--active,
        img {
          border-radius: 4px;
        }
      }
    }
  }
}

.collapse-customize {
  input[type='checkbox'] {
    display: none;
    &:checked {
      ~ .collapse-content {
        .collapse-header {
          .arrow svg {
            transform: rotate(90deg);
            transition: all 0.3s;
          }
        }
        .details {
          max-height: 500px;
          scrollbar-width: none;
          overflow: auto;
          transition: all 1s;
        }
      }
    }
  }

  .collapse-header {
    height: unset;
    padding: 12px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .arrow svg {
      transform: rotate(-90deg);
      transition: all 0.3s;
    }
    p {
      margin: 0;
    }
  }
  .details {
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s;
  }
}

.product {
  &__breadcrumb {
    margin: 0;

    @include media-md-up {
      padding: 0.5em 1.5em;
      background-color: var(--background-color);
      margin-bottom: var(--space-medium);
    }
  }

  &__images {
    grid-area: a;
  }

  &__header {
    grid-area: b;
  }

  &__info {
    grid-area: c;
  }

  &__title {
    font-size: 1.5rem;
    grid-area: d;
  }

  &__sumary-review {
    @include media-md-down {
      grid-area: f;
    }

    &--treatment {
      cursor: pointer;
      position: relative;
      width: fit-content;

      .jdgm-prev-badge {
        display: block !important;

        .jdgm-star {
          transition: opacity 0.2s ease-in-out;

          &:hover {
            opacity: 0.7;
          }

          &:hover + .jdgm-star {
            opacity: 0.9;
          }

          &:has(+ :hover) {
            opacity: 0.9;
          }
        }

        .jdgm-prev-badge__stars::after,
        .prev-badge-wrapper span:not(.average-star-bagde) {
          text-decoration: underline;
          text-decoration-color: var(--color-primary);
          color: var(--color-primary);
        }
      }

      .jdgm-prev-badge__stars {
        cursor: pointer;
      }
    }

    .jdgm-prev-badge {
      display: block !important;
      &:nth-child(n + 2) {
        display: none !important;
      }
    }

    .jdgm-prev-badge__stars {
      display: flex;
      gap: 6px;
      align-items: center;
      cursor: pointer;
      &::after {
        content: 'Review';
        color: var(--color-primary);
        margin-left: 1em;
        font-size: 12px;
      }
    }
    .jdgm-prev-badge__text {
      display: none;
    }
  }

  &__price {
    grid-area: e;

    font-size: 1.75rem;
    line-height: 1;
    margin: 0;
    display: grid;
    align-items: center;
    grid-template-columns:
      max-content auto
      max-content min-content;

    grid-template-areas:
      'c c c'
      'a b no-element';
    gap: 0;
    &-final {
      grid-area: a;
    }
    &-compare {
      grid-area: b;
      margin-left: 1rem;
    }
    .flash-sale-banner {
      grid-area: c;
      margin-bottom: 0.5rem;
    }
  }
  &__price-flash-sale {
    background: #fafafa;
    padding-bottom: 0.5rem;
    .product__price-final {
      margin-left: 0.5rem;
    }
    .product__price-final {
      color: var(--color-secondary);
      font-size: 2.5rem;
    }
  }

  &__price-compare {
    font-size: 1.5rem;
    text-decoration: line-through;
    color: var(--product-compare-at-price-color);
  }

  &__discount-messages {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 600;
    color: var(--color-primary);
  }

  &__discount-message-secondary {
    color: var(--color-secondary);
  }

  &__google-discount-messages {
    display: flex;
    gap: 0.5rem;
    font-size: 12px;
    font-weight: 600;
    color: var(--color-secondary);
    p {
      margin-bottom: 0;
    }
  }
  &__google-discount-action {
    text-decoration: underline;
    color: var(--color-tertiary);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  @include media-md-up {
    &__title {
      margin-top: 0;
      font-size: 1.75rem;
    }

    &__price {
      font-size: 2.5rem;
      font-weight: bold;
      margin-bottom: 0;
    }

    &__price-compare {
      font-size: 2rem;
    }
  }

  .error-message {
    color: var(--color-secondary);
  }

  @include media-md-down {
    .divider {
      margin-bottom: 0;
    }
  }

  .d-flex-wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
    .product__button-group {
      flex: 1;
    }
  }
}

.guide-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  margin-top: 20px;
}

.guide-item {
  text-align: center;
  width: 220px;
}

.image-wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 100%; /* làm tròn ảnh */
  background: #fff;
  padding: 10px;
  border: 3px solid #eee;
}

.step-number {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  background: #ff5400;
  color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
}

.description {
  margin-top: 25px;
  font-size: 16px;
  font-weight: 500;
}
</style>
